export default "__VITE_ASSET__BmKXDUh1__"